(function($) {
    function initGalleryCarousels() {
        if (typeof $.fn.slick === 'undefined') {
            console.warn('Slick não carregado, tentando novamente...');
            setTimeout(initGalleryCarousels, 500);
            return;
        }

        $('.album-carousel').each(function() {
            var $carousel = $(this);
            
            if ($carousel.hasClass('slick-initialized')) {
                return;
            }
            
            $carousel.slick({
                dots: true,
                infinite: false,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                arrows: false,
                lazyLoad: 'ondemand',
                initialSlide: 0,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false
                        }
                    }
                ]
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGalleryCarousels);
    } else {
        initGalleryCarousels();
    }

})(jQuery);
